var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field-wrapper field-wrapper--large field-wrapper--radio" },
    [
      _c(
        "div",
        { class: [_vm.field.cssClass] },
        [
          _vm.field.labelPlacement !== "hidden_label"
            ? _c("p", { staticClass: "label label--radio" }, [
                _vm._v("\n      " + _vm._s(_vm.field.label)),
                _vm.field.isRequired ? _c("sup", [_vm._v("*")]) : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "field-group field-group--radio field-group--radio-gray"
            },
            [
              _c(
                "div",
                { staticClass: "input-radio-wrapper" },
                [
                  _vm._l(_vm.field.choices, function(item, choiceKey) {
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.choice,
                            expression: "choice"
                          }
                        ],
                        class: [_vm.field.label.replace(/ /g, "_")],
                        attrs: {
                          id:
                            "choice-" +
                            _vm.formId +
                            "_" +
                            _vm.fieldKey +
                            "-" +
                            choiceKey,
                          required: _vm.field.isRequired,
                          name: _vm.field.label.replace(/ /g, "_"),
                          type: "radio"
                        },
                        domProps: {
                          value: item.value,
                          checked: _vm._q(_vm.choice, item.value)
                        },
                        on: {
                          change: function($event) {
                            _vm.choice = item.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          attrs: {
                            for:
                              "choice-" +
                              _vm.formId +
                              "_" +
                              _vm.fieldKey +
                              "-" +
                              choiceKey
                          }
                        },
                        [
                          _c("span", { staticClass: "input-radio-text" }, [
                            _vm._v(_vm._s(item.text))
                          ])
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _vm._t("description"),
          _vm._v(" "),
          _vm._t("error")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }